// src/components/createpost/CreatePostAddOns.js

import React from 'react';
import './CreatePostAddOns.css';

import { getPostStyleTheme } from '../../constants/postStyleThemes';
import { getPostActionDestination } from '../../constants/postActionDestinations';

import styleIcon from '../../assets/style-icon.png';
import boostIcon from '../../assets/boost-icon.png';
import plansIcon from '../../assets/plans-icon.png';
import actionIcon from '../../assets/action-icon.png';

function formatStakeBoostLabel(selectedStakeBoost) {
  if (!selectedStakeBoost) return 'Off';

  const amount = Number(selectedStakeBoost.amountPi || 0);
  const hours = Number(selectedStakeBoost.durationHours || 0);

  if (!amount || !hours) return 'Off';

  return `${amount} Pi · ${hours}h`;
}

function formatPostActionLabel(selectedPostAction) {
  if (!selectedPostAction?.destinationKey) {
    return 'Off';
  }

  const destination = getPostActionDestination(
    selectedPostAction.destinationKey
  );

  if (!destination) {
    return 'Off';
  }

  return destination.title;
}

function CreatePostAddOns({
  selectedTheme = 'normal',
  selectedStakeBoost = null,
  selectedPostAction = null,
  canUsePostAction = false,
  onOpenStyleDrawer,
  onOpenBoostDrawer,
  onOpenPlans,
  onOpenActionDrawer,
}) {
  const selectedThemeData = getPostStyleTheme(selectedTheme);
  const boostLabel = formatStakeBoostLabel(selectedStakeBoost);
  const postActionLabel = formatPostActionLabel(selectedPostAction);

  const hasSelectedPostAction =
    Boolean(selectedPostAction?.destinationKey) &&
    Boolean(selectedPostAction?.label);

  return (
    <div className="createpost-addons">
      <div className="createpost-addons-row">
        <button
          type="button"
          className={`createpost-addon-chip ${
            selectedTheme !== 'normal' ? 'is-active' : ''
          }`}
          onClick={onOpenStyleDrawer}
        >
          <span className="createpost-addon-icon-wrap">
            <img
              src={styleIcon}
              alt=""
              className="createpost-addon-icon"
            />
          </span>

          <span className="createpost-addon-copy">
            <strong>Style</strong>
            <em>{selectedThemeData?.label || 'Normal'}</em>
          </span>
        </button>

        <button
          type="button"
          className={`createpost-addon-chip ${
            selectedStakeBoost ? 'is-active' : ''
          }`}
          onClick={onOpenBoostDrawer}
        >
          <span className="createpost-addon-icon-wrap">
            <img
              src={boostIcon}
              alt=""
              className="createpost-addon-icon"
            />
          </span>

          <span className="createpost-addon-copy">
            <strong>Boost</strong>
            <em>{boostLabel}</em>
          </span>
        </button>

        <button
          type="button"
          className="createpost-addon-chip"
          onClick={onOpenPlans}
        >
          <span className="createpost-addon-icon-wrap">
            <img
              src={plansIcon}
              alt=""
              className="createpost-addon-icon"
            />
          </span>

          <span className="createpost-addon-copy">
            <strong>Plans</strong>
            <em>Upgrade</em>
          </span>
        </button>

        {canUsePostAction && (
          <button
            type="button"
            className={`createpost-addon-chip createpost-addon-chip--action ${
              hasSelectedPostAction ? 'is-active' : ''
            }`}
            onClick={onOpenActionDrawer}
          >
            <span className="createpost-addon-icon-wrap">
              <img
                src={actionIcon}
                alt=""
                className="createpost-addon-icon"
              />
            </span>

            <span className="createpost-addon-copy">
              <strong>Action</strong>
              <em>{postActionLabel}</em>
            </span>
          </button>
        )}
      </div>
    </div>
  );
}

export default CreatePostAddOns;
